import { makeEnum } from '../util/mappingLib.js';

const itemToDisplayedEnum = {};

const addDisplayedEnum = (...args) => {
  const enumObject = makeEnum(...args);

  for (const item of enumObject.ALL_ITEMS) {
    if (item in itemToDisplayedEnum && itemToDisplayedEnum[item].ENUM_NAME != enumObject.ENUM_NAME) {
      throw new Error('Enum value already mapped');
    }
    itemToDisplayedEnum[item] = enumObject;
  }

  return enumObject;
};

const enumForDisplayedItem = (item) => itemToDisplayedEnum[item];

export { addDisplayedEnum, enumForDisplayedItem };
